import React from "react";
import RatingBar from "../RatingBar/RatingBar";
import Star from "../SvgIcons/Star";

const UserRating = ({ user }) => {
  const totalRating = Object.values(user.rating).reduce(
    (acc, value) => acc + value,
    0
  );
  return (
    <div className="flex items-start gap-16">
      <div className="flex flex-col gap-2">
        <p className="font-pop text-[39px]">
          <span className="text-ratingText">4.9</span>
          <span className="text-ratingTextGray">/5</span>
        </p>
        <div className="flex">
          <Star className="h-8 w-8 fill-yellow" />
          <Star className="h-8 w-8" />
          <Star className="h-8 w-8" />
          <Star className="h-8 w-8" />
          <Star className="h-8 w-8" />
        </div>
        <p className="font-pop text-xs text-ratingTextLightGray">
          1205 Ratings
        </p>
      </div>
      <div className="flex flex-col gap-3">
        {Object.keys(user.rating).map((rating, index) => (
          <RatingBar rating={rating} totalRating={totalRating} key={index} />
        ))}
      </div>
    </div>
  );
};

export default UserRating;
